import type { FaireProductEntity } from "../../entity_types/product";

export const p_syptnc85d8: FaireProductEntity = {
  token: "p_syptnc85d8",
  type: "product",
  name: "Vintage Anemousite Bronze Natural Stone Adjustable Ring - CS",
  brandToken: "b_nex9pcmkzj",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/6212807c5558d57d90d834f4774663c62107824fd2df67f5b0cd1e33c3ecc293.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6833710c0a6439c81e697ffe1598909f8c20a3e263fe2e80f4e49cc79578d1dd.jpeg",
    "https://cdn.faire.com/fastly/bd73c0eabdc19c5e1741514c1a1998735ca1e6265c26ce22fd4fb8afa1c3fbe7.jpeg",
    "https://cdn.faire.com/fastly/97370ec4b53ad0ca6a7b0d0a8ff4143dd3e503306f64cb6dd87490ed4b7494c1.jpeg",
  ],
  priceDollars: 9.92,
  description:
    "Kind reminder: Stones and crystals are made of natural raw stones, and some stones have cracks, which is a normal phenomenon\n\nType: Ring\n\nMaterial : Stone,Copper alloy \nSize : 7#~8# ,adjustable \n\n★Made of high quality material, Nickel-free / Lead-free, Harmless to Human Body.\n\n★Perfect jewelry gifts\n\n",
  tags: [],
  msrpDollars: 19.84,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:31.928Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
